<template>
  <b-dropdown
    variant="link"
    toggle-class="ga-navbar-search__sort-toggle"
    menu-class="dict-sort-menu__menu ga-navbar-search__sort-menu"
    right
    no-caret
    :title="sortTooltip"
    v-b-tooltip.hover.bottom
    :aria-label="$t('dict.sort_by')"
  >
    <template #button-content>
      <i class="fas fa-sort-amount-down" aria-hidden="true"></i>
    </template>
    <b-dropdown-header class="ga-navbar-search__sort-menu-header">
      {{ $t('dict.sort_by') }}
    </b-dropdown-header>
    <b-dropdown-item
      v-for="option in sortOptions"
      :key="option.value"
      :active="ordering === option.value"
      @click="selectSort(option.value)"
    >{{ option.label }}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { dictionarySortBus } from '@/utils/dictionarySortBus'

export default {
  name: 'DictSortControl',
  data () {
    return {
      ordering: 'top'
    }
  },
  computed: {
    sortOptions () {
      return [
        { value: 'top', label: this.$t('dict.sort_top') },
        { value: 'new', label: this.$t('dict.sort_new') },
        { value: 'alpha', label: this.$t('dict.sort_alpha') },
        { value: 'omega', label: this.$t('dict.sort_omega') }
      ]
    },
    sortLabel () {
      const match = this.sortOptions.find(o => o.value === this.ordering)
      return match ? match.label : this.$t('dict.sort_top')
    },
    sortTooltip () {
      return `${this.$t('dict.sort_by')} ${this.sortLabel}`
    }
  },
  created () {
    dictionarySortBus.$on('sort-state', this.onSortState)
  },
  beforeDestroy () {
    dictionarySortBus.$off('sort-state', this.onSortState)
  },
  methods: {
    onSortState (ordering) {
      this.ordering = ordering || 'top'
    },
    selectSort (value) {
      dictionarySortBus.$emit('sort-change', value)
    }
  }
}
</script>
